(()=>{
 if(window.parkHairtestModalReady)return;window.parkHairtestModalReady=true;
 const openers=new WeakMap();
 const init=dialog=>{
  if(dialog.dataset.modalReady)return;dialog.dataset.modalReady='true';
  dialog.querySelector('[data-hairtest-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{
   const opener=openers.get(dialog);opener?.setAttribute('aria-expanded','false');opener?.focus({preventScroll:true});
  });
  dialog.addEventListener('click',event=>{
   if(event.target!==dialog)return;
   const rect=dialog.getBoundingClientRect();
   if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
  });
 };
 document.addEventListener('click',event=>{
  const trigger=event.target.closest('[data-hairtest-trigger]');
  if(!trigger)return;
  trigger.dispatchEvent(new CustomEvent('park:hairtest-open',{bubbles:true}));
 });
 document.addEventListener('park:hairtest-open',event=>{
  const host=event.target.closest('[data-hairtest-popup]');if(!host)return;
  const dialog=document.getElementById(host.dataset.hairtestDialog);if(!dialog)return;
  init(dialog);
  const opener=host.querySelector('[data-action="start"]');openers.set(dialog,opener);
  opener.setAttribute('aria-controls',dialog.id);opener.setAttribute('aria-expanded','true');
  if(!dialog.open)dialog.showModal();
  const frame=dialog.querySelector('[data-park-frame-url]');if(frame)window.PARKHairtestFrame.load(frame);
 });
})();
